import React, { useState } from "react";
import { fetchWithAuth } from "../utils/apiHelper";
import { toast } from "react-toastify";
import { XCircleIcon, CurrencyDollarIcon } from "@heroicons/react/24/solid";

const SenaModal = ({ isOpen, onClose, turnoId, onSenaGuardada, onConfirmSena }) => {
  const [monto, setMonto] = useState("");
  const [metodoPago, setMetodoPago] = useState("Efectivo");
  const [loading, setLoading] = useState(false);
  

  const handleGuardar = async () => {
    if (!monto || monto <= 0) {
      toast.error("Ingresa un monto válido.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetchWithAuth("/senas/agregar", {
        method: "POST",
        body: JSON.stringify({ turno_id: turnoId, monto, metodo_pago: metodoPago }),
      });

      onSenaGuardada(response.sena);
      onConfirmSena()
      onClose();
    } catch (error) {
      console.error("Error al registrar la sena:", error);
      toast.error("Error al registrar la sena.");
    } finally {
      setLoading(false);
    }
  };



  const Cerrar = () =>{
    onClose()
}


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm z-50">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-fade-in">
        {/* Botón de cierre */}
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-600 hover:text-gray-800 transition">
          <XCircleIcon className="h-6 w-6" />
        </button>

        {/* Encabezado */}
        <div className="text-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">Registrar Sena</h2>
          <p className="text-sm text-gray-500">Agrega un pago adelantado para este turno.</p>
        </div>

        {/* Icono */}
        <div className="flex justify-center">
          <CurrencyDollarIcon className="h-14 w-14 text-yellow-500 drop-shadow-lg" />
        </div>

        {/* Campos del formulario */}
        <div className="mt-6 space-y-4">
          <div>
            <label className="block text-gray-700 font-semibold">Monto</label>
            <input
              type="number"
              placeholder="Ingrese el monto"
              value={monto}
              onChange={(e) => setMonto(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-yellow-300 focus:border-yellow-500 transition duration-200"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold">Método de Pago</label>
            <select
              value={metodoPago}
              onChange={(e) => setMetodoPago(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring focus:ring-yellow-300 focus:border-yellow-500 transition duration-200"
            >
              <option value="Efectivo">Efectivo</option>
              <option value="Tarjeta">Tarjeta</option>
              <option value="Transferencia">Transferencia</option>
            </select>
          </div>
        </div>

        {/* Botones */}
        <div className="mt-6 flex justify-between">
          <button
            onClick={Cerrar}
            className="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg font-semibold transition duration-200"
          >
            Cancelar
          </button>
          <button
            onClick={handleGuardar}
            disabled={loading}
            className={`px-4 py-2 text-white font-semibold rounded-lg transition duration-200 ${
              loading
                ? "bg-yellow-300 cursor-not-allowed"
                : "bg-yellow-500 hover:bg-yellow-600"
            }`}
          >
            {loading ? "Guardando..." : "Guardar Sena"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SenaModal;
